import { projektGajaChapters } from './content';
export const projektGajaFaq = projektGajaChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('FAQ'));
